module.exports = __webpack_public_path__ + "samoa.svg?414be2a73d815adf04c79b0b0389e5c8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/samoa.svg
// module id = 281
// module chunks = 10